module.exports = __webpack_public_path__ + "img/Media-Radio.510d9060.svg";